"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopilotContextList = void 0;
const react_1 = __importStar(require("react"));
const models_hook_1 = require("app/models.hook");
const referenceTranslationIdMatcher_1 = require("@/utils/referenceTranslationIdMatcher");
const diff_1 = require("utils/diff");
const components_1 = require("utils/components");
const ExactMessage = ({ ignored }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { style: {
                fontWeight: "bold",
            } },
            ignored && (react_1.default.createElement(react_1.default.Fragment, null, "\u901A\u5E38\u3001\u5B8C\u5168\u4E00\u81F4\u3059\u308B\u53C2\u7167\u8A33\u304C\u3042\u308B\u5834\u5408\u3001\u305D\u306E\u8A33\u304C\u63A1\u7528\u3055\u308C\u307E\u3059\u304C\u3001 \u73FE\u5728\u306E\u8A2D\u5B9A\u3067\u306F\u3001\u7FFB\u8A33\u306E\u54C1\u8CEA\u3092\u8A55\u4FA1\u3059\u308B\u305F\u3081\u3001 \u5B8C\u5168\u4E00\u81F4\u3059\u308B\u53C2\u7167\u8A33\u306F\u7121\u8996\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3053\u306E\u8A2D\u5B9A\u3092\u5909\u66F4\u3059\u308B\u5834\u5408\u306F\u3001")),
            !ignored && (react_1.default.createElement(react_1.default.Fragment, null, "\u5B8C\u5168\u4E00\u81F4\u3059\u308B\u53C2\u7167\u8A33\u304C\u3042\u308B\u305F\u3081\u3001\u3053\u306E\u8A33\u304C\u7FFB\u8A33\u3068\u3057\u3066\u63A1\u7528\u3055\u308C\u3066\u3044\u307E\u3059\u3002 \u7FFB\u8A33\u306E\u54C1\u8CEA\u3092\u8A55\u4FA1\u3059\u308B\u305F\u3081\u306B\u3001\u3053\u306E\u8A2D\u5B9A\u3092\u5909\u66F4\u3059\u308B\u5834\u5408\u306F\u3001")),
            react_1.default.createElement(components_1.SidePanelLink, { sidePanelKind: "translation-settings" }, "\u7FFB\u8A33\u8A2D\u5B9A"),
            "\u304B\u3089\u4FEE\u6B63\u3057\u3066\u304F\u3060\u3055\u3044\u3002")));
};
const orderReferences = (scripts, text, ignoreExactMatchedReference) => {
    const perfectlyMatched = scripts
        .filter((ref) => ref.script.text.trim() === text.trim())
        .map((ref) => (Object.assign(Object.assign({}, ref), { ignored: ref.ignored || ignoreExactMatchedReference })));
    if (!ignoreExactMatchedReference && perfectlyMatched.length > 0)
        return perfectlyMatched;
    const notPerfectlyMatched = scripts.filter((ref) => ref.script.text.trim() !== text.trim());
    const usedWords = notPerfectlyMatched.filter((ref) => ref.script.isWord && !ref.ignored);
    const usedReferences = notPerfectlyMatched.filter((ref) => !ref.script.isWord && !ref.ignored);
    const unusedWords = notPerfectlyMatched.filter((ref) => ref.script.isWord && ref.ignored);
    const unusedReferences = notPerfectlyMatched.filter((ref) => !ref.script.isWord && ref.ignored);
    return [
        ...perfectlyMatched,
        ...usedWords,
        ...usedReferences,
        ...unusedWords,
        ...unusedReferences,
    ];
};
const CopilotContextList = ({ context, projectId, diffOriginal, diffTranslated, langId, onApply, }) => {
    const mergedScripts = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        return [
            ...((_a = context === null || context === void 0 ? void 0 : context.scripts) !== null && _a !== void 0 ? _a : []).map((script) => ({
                ignored: false,
                script,
            })),
            ...((_b = context === null || context === void 0 ? void 0 : context.ignoredScripts) !== null && _b !== void 0 ? _b : []).map((script) => ({
                ignored: true,
                script,
            })),
            ...((_c = context === null || context === void 0 ? void 0 : context.ignoredWordScripts) !== null && _c !== void 0 ? _c : []).map((script) => ({
                ignored: true,
                script,
            })),
        ].sort((a, b) => a.script.id.localeCompare(b.script.id));
    }, [context === null || context === void 0 ? void 0 : context.scripts, context === null || context === void 0 ? void 0 : context.ignoredScripts]);
    const orderedScripts = (0, react_1.useMemo)(() => {
        var _a;
        return orderReferences(mergedScripts, diffOriginal, (_a = context === null || context === void 0 ? void 0 : context.ignoreExactMatchedReference) !== null && _a !== void 0 ? _a : false);
    }, [mergedScripts, diffOriginal]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        context && context.exactMatched && (react_1.default.createElement(ExactMessage, { ignored: !!context.ignoreExactMatchedReference })),
        react_1.default.createElement("ul", null, orderedScripts.map((item) => (react_1.default.createElement(ScriptTableRow, { item: item, projectId: projectId, key: item.script.id, isIgnoredInCachedDataContextData: item.ignored, diffTranslated: diffTranslated, diffOriginal: diffOriginal, langId: langId, onApply: onApply }))))));
};
exports.CopilotContextList = CopilotContextList;
const diffCharacter = new diff_1.Diff("character");
const ScriptTableRow = ({ item, isIgnoredInCachedDataContextData = false, projectId, diffOriginal, diffTranslated, langId, onApply, }) => {
    const { data, set } = (0, models_hook_1.useProjectDoc)({ projectId });
    // Here, we calculate if the item is ignored using the context data and the ProjectDoc data.
    const isIgnored = (0, react_1.useMemo)(() => {
        var _a;
        // projectData initially has only projectId, and later it will be updated with the data from the server.
        // createdAt is a required field, so we can use it to check if the data is ready.
        if (!data.createdAt)
            return isIgnoredInCachedDataContextData;
        return (_a = data.ignoredReferenceTranslationIds) === null || _a === void 0 ? void 0 : _a.some((pattern) => (0, referenceTranslationIdMatcher_1.isIgnoredReferenceTranslationIdMatchesReferenceId)(pattern, item.script.id));
    }, [data, isIgnoredInCachedDataContextData, item.script.id]);
    const activate = (0, react_1.useCallback)(() => {
        var _a, _b, _c;
        if (!isIgnored)
            return;
        // projectData initially has only projectId, and later it will be updated with the data from the server.
        // createdAt is a required field, so we can use it to check if the data is ready.
        if (!data.createdAt)
            return;
        const ignoredPatternsToBeRemoved = new Set(((_a = data.ignoredReferenceTranslationIds) !== null && _a !== void 0 ? _a : []).filter((pattern) => (0, referenceTranslationIdMatcher_1.isIgnoredReferenceTranslationIdMatchesReferenceId)(pattern, item.script.id)));
        if (ignoredPatternsToBeRemoved.size === 0)
            return;
        set(Object.assign(Object.assign({}, data), { ignoredReferenceTranslationIds: (_c = (_b = data.ignoredReferenceTranslationIds) === null || _b === void 0 ? void 0 : _b.filter((pattern) => !ignoredPatternsToBeRemoved.has(pattern))) !== null && _c !== void 0 ? _c : [] }));
    }, [item, data, set, isIgnored]);
    const deactivate = (0, react_1.useCallback)(() => {
        var _a;
        if (isIgnored)
            return;
        // projectData initially has only projectId, and later it will be updated with the data from the server.
        // createdAt is a required field, so we can use it to check if the data is ready.
        if (!data.createdAt)
            return;
        set(Object.assign(Object.assign({}, data), { ignoredReferenceTranslationIds: [
                ...((_a = data.ignoredReferenceTranslationIds) !== null && _a !== void 0 ? _a : []),
                item.script.id,
            ] }));
    }, [item, data, set, isIgnored]);
    const originalHighlighted = (0, react_1.useMemo)(() => {
        return diffCharacter
            .calculate(diffOriginal, item.script.text)
            .map(([, refOriginal]) => refOriginal);
    }, [diffOriginal, item.script.text]);
    const transcriptHighlighted = (0, react_1.useMemo)(() => {
        const diffType = (0, diff_1.estimateSplitType)(langId);
        const diffClass = new diff_1.Diff(diffType);
        return diffClass
            .calculate(diffTranslated, item.script.translation)
            .map(([, refTranscript]) => refTranscript);
    }, [langId, diffTranslated, item.script.translation]);
    return (react_1.default.createElement("li", { style: {
            display: "flex flex-col",
        }, className: "border-bottom" },
        react_1.default.createElement("section", { className: "d-flex justify-content-between w-100" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(HighlightText, { text: item.script.text, highlightPositions: originalHighlighted, type: "character", bold: true }),
                !!item.script.isWord && (react_1.default.createElement("span", { style: {
                        marginLeft: "10px",
                        fontWeight: "bold",
                        backgroundColor: "#cdd5ff",
                        borderRadius: "5px",
                        padding: "2px 5px",
                        fontSize: "0.8em",
                    } }, "\u5358\u8A9E")),
                !item.ignored && (react_1.default.createElement("span", { style: {
                        marginLeft: "10px",
                        fontWeight: "bold",
                        backgroundColor: "#2D73B9",
                        borderRadius: "6px",
                        padding: "2px 5px",
                        fontSize: "8px",
                        color: "white",
                        textWrap: "nowrap",
                    } }, "\u53C2\u7167\u8A33\u3068\u3057\u3066\u5229\u7528\u4E2D"))),
            react_1.default.createElement("div", { style: { padding: "10px 0 10px 0", flex: "0 0 auto" }, className: "text-nowrap" },
                react_1.default.createElement("div", { className: "form-check form-switch" },
                    react_1.default.createElement("input", { className: "form-check-input", type: "checkbox", role: "switch", checked: !isIgnored, onChange: isIgnored ? activate : deactivate, "data-tooltip-id": "tooltip", "data-tooltip-content": "参照訳に利用(この設定はプロジェクト全体に影響します)" })))),
        react_1.default.createElement("button", { className: "btn btn-light w-100", onClick: () => onApply(item.script.translation), style: { textAlign: "left" } },
            react_1.default.createElement(HighlightText, { text: item.script.translation, highlightPositions: transcriptHighlighted, type: (0, diff_1.estimateSplitType)(langId) }))));
};
const HighlightText = ({ text, highlightPositions, type, bold }) => {
    const split = (0, react_1.useMemo)(() => {
        if (type === "word")
            return (0, diff_1.DiffWordSplitter)(text);
        if (type === "character")
            return (0, diff_1.DiffCharacterSplitter)(text);
        return [];
    }, [type, text]);
    return (react_1.default.createElement(react_1.default.Fragment, null, split.map((v, i) => (react_1.default.createElement("span", { key: i, style: {
            color: highlightPositions.includes(i) ? "#995400" : undefined,
            backgroundColor: highlightPositions.includes(i)
                ? "#facc15"
                : undefined,
            fontWeight: bold ? "bold" : undefined,
            wordBreak: "break-all",
        } },
        i !== 0 && type === "word" ? " " : "",
        v)))));
};
